import { render, staticRenderFns } from "./AlbumCard.vue?vue&type=template&id=0b23a67c&scoped=true"
import script from "./AlbumCard.vue?vue&type=script&lang=js"
export * from "./AlbumCard.vue?vue&type=script&lang=js"
import style0 from "./AlbumCard.vue?vue&type=style&index=0&id=0b23a67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23a67c",
  null
  
)

export default component.exports